import React from 'react'
import { useTranslation } from 'react-i18next'
import Icon from '../../../../../components/icons'
import Button from '../../../../../elements/button'
import { Link } from 'react-router-dom'
import { URLS } from '../../../../../_config'

interface SaveFeaturesSuccessModalProps {
    _ref: any
    dataTestId?: string
}

const SaveFeaturesSuccessModal: React.FC<SaveFeaturesSuccessModalProps> = ({ _ref, dataTestId }) => {
    const { t } = useTranslation()
    return (
        <dialog ref={_ref} className="modal" data-testid={dataTestId || 'save-features-modal'}>
            <div className="modal-box" data-testid="save-features-modal-box">
                <p className="font-bold text-center text-[1.333rem] leading-8" data-testid="success-modal-title">
                    {t('Query Saved Successfull')}
                </p>

                <div className="flex justify-center">
                    <img alt={t('success gif')} src="/assets/images/success.gif" className="w-[14rem]" data-testid="success-image" />
                </div>

                <div className="flex justify-center gap-2">
                    <Link to={URLS.DATA_ONBOARDING} data-testid="preview-link">
                        <Button theme="secondary" size="sm" styleType="outline" data-testid="preview-button">
                            <Icon name="eye" />
                            {t('Preview')}
                        </Button>
                    </Link>
                    <Button
                        theme="secondary"
                        size="sm"
                        className="text-white"
                        onClick={() => {
                            _ref.current.close()
                        }}
                    >
                        <Icon name="circle-check" />
                        {t('Done')}
                    </Button>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button">{t('close')}</button>
            </form>
        </dialog>
    )
}

export default SaveFeaturesSuccessModal
